import React from 'react';
import { Shield, Info } from 'lucide-react';

/**
 * SecurityServicesHeader - Header component for the Security Services Matrix
 * Displays title, description, and internal mode indicator
 */
const SecurityServicesHeader = () => {
  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Shield className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Security Services Matrix</h1>
                <p className="text-sm text-gray-600 mt-1">
                  Comprehensive comparison of security services capabilities and features
                </p>
              </div>
            </div>
          </div>
          
          {/* Internal Mode Indicator */}
          <div className="flex items-center space-x-2">
            <div className="flex items-center px-3 py-1.5 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">
              <Info className="w-4 h-4 mr-1" />
              Internal Use Only
            </div>
          </div>
        </div>
        
        {/* Additional Info */}
        <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <div className="flex items-start space-x-3">
            <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm">
              <p className="text-blue-800 font-medium">Security Services Comparison Matrix</p>
              <p className="text-blue-700 mt-1">
                This matrix provides a comprehensive overview of available security services and their capabilities. 
                Use the filters below to narrow down services by category or search for specific features.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityServicesHeader; 